(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-tab-block"] && !Shopify.designMode) return;
  try {
    
    class BrandsTab extends HTMLElement {
        constructor() {
            super();
            this.tabTitle = this.querySelector('.tab-title');
            this.tabContent = this.querySelector('.tab-panel-content');
            const ele = this.querySelectorAll('[tab-title-action]');
            const actionLoadMore = this.querySelectorAll('[data-load-more-block]');
            this.widthWindow = 0;
            if (ele.length) {
                ele.forEach((button) => button.addEventListener('click', this.onActive.bind(this)));
            }
            if (actionLoadMore.length) {
                actionLoadMore.forEach((button) => button.addEventListener('click', this.onLoadMore.bind(this)));
            }
        }

        onActive(e) {
            this.tabTitle.querySelector('.active').classList.remove('active');
            this.tabContent.querySelector('.active').classList.remove('active');
            this.querySelector(e.target.dataset.target).classList.add('active');
            e.target.parentElement.classList.add('active');
        }
        onLoadMore(e) {
            this.resize();
            if (this.widthWindow > 1024) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-lg');
                var _number = e.target.dataset.rowlg;
                var _class = 'hidden-lg';
                
            } else if(this.widthWindow > 551) {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-md');
                var _number = 9;
                var _class = 'hidden-md';
            } else {
                var eleHide = (e.target.parentElement).querySelectorAll('.hidden-sm');
                var _number = 6;
                var _class = 'hidden-sm';
            }
            if (eleHide.length) {
                // let number_show = (eleHide.length > number ? number : eleHide.length);
                if (e.target.classList.contains('more')) {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.remove('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonmore;
                    e.target.classList.remove('more');
                } else {
                    for (let i = 0; i < eleHide.length; i++) {
                        eleHide[i].classList.add('show');
                    }
                    e.target.querySelector('span').textContent = e.target.dataset.buttonless;
                    e.target.classList.add('more');
                }

                // (eleHide.length > _number ? '' : e.target.classList.add('hidden'));
            }
        }
        resize() {
            this.widthWindow = window.innerWidth;
        }
    }
    customElements.define('brand-tab', BrandsTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-mobile"]) return;
  try {
    
    class StickyHeaderMobile extends HTMLElement {
        connectedCallback() {
            this.header = document.querySelector('.section-header-mobile');
            if (!this.header) return;

            this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
            this.currentScrollTop = 0;
            this.headerBounds = { top: 0, bottom: 0 };
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');
            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;

            if (this.headerIsAlwaysSticky) this.header.classList.add('shopify-section-header-sticky');
            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);
            this.createObserver();
        }

        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            if (!window.IntersectionObserver || !this.header) return;
            const observer = new IntersectionObserver((entries) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
            observer.observe(this.header);
        }

        onScroll() {
            if (!this.header || document.body.classList.contains('lashmer-mobile-menu-open')) return;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventHide) requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    clearTimeout(this.isScrolling);
                    this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this));
            }

            this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
            this.header.classList.remove('shopify-section-header-show');
            this.header.style.top = '';
        }

        reveal() {
            if (this.headerIsAlwaysSticky) return;
            const multiSiteHeader = document.querySelector('.section-header-nav-multi-site');
            this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
            this.header.classList.remove('shopify-section-header-hidden');
            this.header.style.top = multiSiteHeader ? `${multiSiteHeader.offsetHeight}px` : '';
        }

        reset() {
            if (this.headerIsAlwaysSticky) return;
            this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
            this.header.style.top = '';
        }
    }

    if (!customElements.get('sticky-header-mobile')) {
        customElements.define('sticky-header-mobile', StickyHeaderMobile);
    }

    (function () {
        if (window.__lashmerMobileMenuControllerV32) return;
        window.__lashmerMobileMenuControllerV32 = true;

        const BREAKPOINT = 1024;
        const MAIN_INDEX = '1';
        const ACTIVE_TAB_KEY = 'lashmer_mobile_menu_active_tab_v31';
        const DRAWER_TRANSITION_MS = 560;
        let lastFocusedElement = null;
        let closeTimer = null;

        function isMobile() {
            return window.innerWidth <= BREAKPOINT;
        }


        function getDrawer() {
            return document.querySelector('[data-lashmer-mobile-drawer]');
        }

        function getPanel() {
            const drawer = getDrawer();
            return drawer ? drawer.querySelector('.lashmer-mobile-menu__panel') : null;
        }

        function getSource() {
            return document.querySelector('[data-mobile-menu-tabs-source]');
        }

        function getRoot() {
            const drawer = getDrawer();
            return drawer ? drawer.querySelector('[data-lashmer-mobile-menu-root]') : null;
        }

        function getTabsHost() {
            const drawer = getDrawer();
            return drawer ? drawer.querySelector('[data-lashmer-mobile-tabs]') : null;
        }

        function getTemplate(index) {
            const source = getSource();
            if (!source || !index) return null;
            return source.querySelector('[data-mobile-menu-tab-template][data-mobile-menu-tab-index="' + index + '"]');
        }

        function templateHasItems(template) {
            if (!template) return false;
            if (template.content && template.content.querySelector('.menu-lv-1')) return true;
            return (template.innerHTML || '').indexOf('menu-lv-1') !== -1;
        }

        function getAvailableIndexes() {
            const source = getSource();
            if (!source) return [];
            return Array.prototype.slice.call(source.querySelectorAll('[data-mobile-menu-tab-template]')).filter(templateHasItems).map(function (template) {
                return template.getAttribute('data-mobile-menu-tab-index');
            }).filter(Boolean);
        }

        function getDefaultIndex() {
            const indexes = getAvailableIndexes();
            if (indexes.indexOf(MAIN_INDEX) !== -1) return MAIN_INDEX;
            return indexes[0] || '';
        }

        function canUseIndex(index) {
            return !!(index && templateHasItems(getTemplate(index)));
        }

        function getStoredIndex() {
            try {
                const stored = window.localStorage ? localStorage.getItem(ACTIVE_TAB_KEY) : '';
                return canUseIndex(stored) ? stored : '';
            } catch (error) {
                return '';
            }
        }

        function rememberIndex(index) {
            if (!canUseIndex(index)) return;
            try {
                if (window.localStorage) localStorage.setItem(ACTIVE_TAB_KEY, index);
            } catch (error) {}
        }

        function getOpenIndex() {
            return getStoredIndex() || getDefaultIndex();
        }

        function canUseOwnDrawer() {
            return !!(getDrawer() && getSource() && getDefaultIndex());
        }

        function unlockHamburger() {
            document.querySelectorAll('[data-lashmer-menu-toggle], .lashmer-mobile-hamburger').forEach(function (button) {
                button.removeAttribute('disabled');
                button.setAttribute('aria-disabled', 'false');
                button.removeAttribute('aria-busy');
                button.removeAttribute('data-lashmer-menu-loading');
                button.setAttribute('data-lashmer-menu-ready', 'true');
                button.classList.remove('is-loading');
                button.classList.add('is-ready');
            });
        }

        function buildTabs() {
            const source = getSource();
            const host = getTabsHost();
            if (!source || !host) return;

            if (!host.querySelector('[data-mobile-menu-tabs-bar]')) {
                const barTemplate = source.querySelector('[data-mobile-menu-tabs-bar-template]');
                if (barTemplate) {
                    const bar = barTemplate.cloneNode(true);
                    bar.removeAttribute('data-mobile-menu-tabs-bar-template');
                    bar.setAttribute('data-mobile-menu-tabs-bar', '');
                    bar.removeAttribute('hidden');
                    bar.style.cssText = source.getAttribute('style') || '';
                    host.appendChild(bar);
                }
            }

            if (!host.querySelector('[data-mobile-menu-tabs-helper]')) {
                const helperTemplate = source.querySelector('[data-mobile-menu-tabs-helper-template]');
                if (helperTemplate) {
                    const helper = helperTemplate.cloneNode(true);
                    helper.removeAttribute('data-mobile-menu-tabs-helper-template');
                    helper.setAttribute('data-mobile-menu-tabs-helper', '');
                    helper.removeAttribute('hidden');
                    host.appendChild(helper);
                }
            }
        }

        function setActiveTab(index) {
            document.querySelectorAll('[data-lashmer-mobile-drawer] [data-mobile-menu-tab-button]').forEach(function (button) {
                const active = button.getAttribute('data-mobile-menu-tab-index') === index;
                button.classList.toggle('is-active', active);
                button.setAttribute('aria-selected', active ? 'true' : 'false');
            });
        }

        function directChildren(element) {
            return Array.prototype.slice.call(element ? element.children || [] : []);
        }

        function getLevel(item) {
            if (item.classList.contains('menu-lv-1')) return 1;
            if (item.classList.contains('menu-lv-2')) return 2;
            if (item.classList.contains('menu-lv-3')) return 3;
            return 0;
        }

        function getTrigger(item) {
            return directChildren(item).find(function (child) {
                return child.matches && child.matches('a, button, .menu-lv-1__action, .menu-lv-2__action, .site-nav-title');
            }) || null;
        }

        function getDirectSubmenu(item) {
            const level = getLevel(item);
            if (level >= 3) return null;
            const childSelector = level === 1 ? '.menu-lv-2' : '.menu-lv-3';
            const trigger = getTrigger(item);

            let submenu = directChildren(item).find(function (child) {
                if (child === trigger) return false;
                return child.matches && child.matches('.menu-lv__dropdownmenu, .site-nav-dropdown, .menu-dropdown, .submenu, .sub-menu, ul, .list-menu');
            });

            if (submenu) return submenu;

            submenu = directChildren(item).find(function (child) {
                if (child === trigger) return false;
                return !!(child.querySelector && child.querySelector(childSelector));
            });

            return submenu || null;
        }

        function markNestedMenus(root) {
            if (!root) return;

            root.querySelectorAll('.is-open').forEach(function (item) {
                item.classList.remove('is-open');
            });

            root.querySelectorAll('[data-lashmer-submenu]').forEach(function (submenu) {
                submenu.removeAttribute('data-lashmer-submenu');
            });

            root.querySelectorAll('[data-lashmer-trigger]').forEach(function (trigger) {
                trigger.removeAttribute('data-lashmer-trigger');
                trigger.removeAttribute('aria-haspopup');
                trigger.setAttribute('aria-expanded', 'false');
            });

            root.querySelectorAll('.menu-lv-1, .menu-lv-2').forEach(function (item) {
                const submenu = getDirectSubmenu(item);
                const trigger = getTrigger(item);
                if (!submenu || !trigger) return;

                submenu.setAttribute('data-lashmer-submenu', getLevel(item) === 1 ? '2' : '3');
                trigger.setAttribute('data-lashmer-trigger', getLevel(item) === 1 ? '1' : '2');
                trigger.setAttribute('aria-haspopup', 'true');
                trigger.setAttribute('aria-expanded', 'false');
            });
        }

        function loadMenu(index) {
            const root = getRoot();
            const template = getTemplate(index);
            if (!root || !templateHasItems(template)) return false;

            root.innerHTML = template.innerHTML;
            root.setAttribute('data-lashmer-active-index', index);
            markNestedMenus(root);
            setActiveTab(index);

            const loaded = !!root.querySelector('.menu-lv-1');
            if (loaded) rememberIndex(index);
            return loaded;
        }

        function closeExternalDrawers() {
            document.body.classList.remove('menu_open', 'open_menu', 'open-menu');
            document.documentElement.classList.remove('menu_open', 'open_menu', 'open-menu');
        }

        function resetScroll() {
            const scroll = document.querySelector('[data-lashmer-mobile-menu-scroll]');
            if (scroll) scroll.scrollTop = 0;
        }

        function openMenu() {
            if (!isMobile() || !canUseOwnDrawer()) return false;

            const drawer = getDrawer();
            const panel = getPanel();
            const index = getOpenIndex();

            closeExternalDrawers();
            buildTabs();

            if (!loadMenu(index)) return false;

            if (closeTimer) {
                window.clearTimeout(closeTimer);
                closeTimer = null;
            }

            lastFocusedElement = document.activeElement;
            drawer.hidden = false;
            drawer.classList.remove('is-open');
            drawer.classList.add('is-mounted');
            drawer.setAttribute('aria-hidden', 'false');
            resetScroll();

            /*
                Use a double animation frame before adding the open state.
                This prevents the homepage transparent/absolute header initialization from collapsing
                the starting transform and makes the left-to-right transition reliable on the index page.
            */
            void drawer.offsetWidth;
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    drawer.classList.add('is-open');
                    document.body.classList.add('lashmer-mobile-menu-open');
                });
            });

            window.setTimeout(function () {
                const closeButton = drawer.querySelector('.lashmer-mobile-menu__close');
                if (closeButton) closeButton.focus({ preventScroll: true });
                else if (panel) panel.focus({ preventScroll: true });
            }, 80);

            return true;
        }

        function closeMenu(immediate) {
            const drawer = getDrawer();
            if (!drawer) return;

            if (closeTimer) {
                window.clearTimeout(closeTimer);
                closeTimer = null;
            }

            document.body.classList.remove('lashmer-mobile-menu-open');
            drawer.classList.remove('is-open');
            drawer.setAttribute('aria-hidden', 'true');

            const finishClose = function () {
                drawer.classList.remove('is-mounted');
                drawer.hidden = true;

                const root = getRoot();
                if (root) {
                    root.querySelectorAll('.is-open').forEach(function (item) {
                        item.classList.remove('is-open');
                    });
                    root.querySelectorAll('[aria-expanded="true"]').forEach(function (trigger) {
                        trigger.setAttribute('aria-expanded', 'false');
                    });
                }

                if (lastFocusedElement && lastFocusedElement.focus) {
                    window.setTimeout(function () {
                        try { lastFocusedElement.focus({ preventScroll: true }); } catch (error) {}
                    }, 0);
                }
            };

            if (immediate || drawer.hidden) {
                finishClose();
            } else {
                closeTimer = window.setTimeout(function () {
                    closeTimer = null;
                    finishClose();
                }, DRAWER_TRANSITION_MS);
            }
        }

        function isOpen() {
            const drawer = getDrawer();
            return !!(drawer && !drawer.hidden);
        }

        function toggleNestedItem(item) {
            const trigger = getTrigger(item);
            const open = !item.classList.contains('is-open');
            item.classList.toggle('is-open', open);
            if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        }

        document.addEventListener('click', function (event) {
            const button = event.target && event.target.closest ? event.target.closest('[data-lashmer-menu-toggle], .lashmer-mobile-hamburger') : null;
            if (!button || !isMobile() || !canUseOwnDrawer()) return;

            event.preventDefault();
            event.stopPropagation();
            if (event.stopImmediatePropagation) event.stopImmediatePropagation();

            if (isOpen()) closeMenu();
            else openMenu();
        }, true);



        document.addEventListener('click', function (event) {
            if (!event.target || !event.target.closest) return;

            const closeTarget = event.target.closest('[data-lashmer-menu-close]');
            if (closeTarget) {
                event.preventDefault();
                closeMenu();
                return;
            }

            const tabButton = event.target.closest('[data-lashmer-mobile-drawer] [data-mobile-menu-tab-button]');
            if (tabButton) {
                event.preventDefault();
                event.stopPropagation();
                const index = tabButton.getAttribute('data-mobile-menu-tab-index');
                if (index) {
                    loadMenu(index);
                    resetScroll();
                }
                return;
            }

            const trigger = event.target.closest('[data-lashmer-mobile-drawer] [data-lashmer-trigger]');
            if (!trigger) return;

            const item = trigger.closest('.menu-lv-1, .menu-lv-2');
            if (!item || !getDirectSubmenu(item)) return;

            event.preventDefault();
            event.stopPropagation();
            if (event.stopImmediatePropagation) event.stopImmediatePropagation();
            toggleNestedItem(item);
        }, true);

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape' && isOpen()) closeMenu();
        });

        function boot() {
            unlockHamburger();
            buildTabs();
            closeMenu(true);
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', boot);
        } else {
            boot();
        }

        window.addEventListener('load', unlockHamburger);
        document.addEventListener('shopify:section:load', boot);

        window.addEventListener('resize', function () {
            unlockHamburger();
            if (!isMobile()) closeMenu(true);
        });

        if (window.MutationObserver) {
            new MutationObserver(function () {
                unlockHamburger();
            }).observe(document.documentElement, {
                childList: true,
                subtree: true
            });
        }
    })();

    function renderLogoMobile() {
        if (typeof window.jQuery === 'undefined' || typeof $ === 'undefined') return;
        if ($('[data-menu-tab]').length === 0) return;

        $(document).on('click', '[data-menu-tab] li', function (event) {
            var active = $(event.currentTarget).data('load-page');
            if ($.cookie) $.cookie('page-url', active, { expires: 1, path: '/' });
        });

        if (!$.cookie) return;

        var pageUrl = $.cookie('page-url');
        if (window.location.pathname.indexOf('/pages/') !== -1 && window.page_active && window.page_active !== pageUrl) {
            document.cookie = 'page-url=' + window.page_active + ';path=/';
            pageUrl = window.page_active;
        }

        var menuTabItem = pageUrl ? $('[data-load-page="' + pageUrl + '"]') : $('[data-load-page].is-active');
        var logoTabItem = pageUrl ? $('[data-load-logo-page="' + pageUrl + '"]') : $('[data-load-logo-page].first');
        var menuItem = pageUrl ? $('[data-load-menu-page="' + pageUrl + '"]') : $('[data-load-menu-page].is-active');
        var menuTab = menuTabItem.closest('[data-menu-tab]');

        menuTab.find('[data-load-page]').not(menuTabItem).removeClass('is-active');
        logoTabItem.siblings().removeClass('is-active');
        menuItem.siblings().removeClass('is-active');

        if (pageUrl) {
            logoTabItem.addClass('is-active');
            menuTabItem.addClass('is-active');
            menuItem.addClass('is-active');
        } else {
            $('[data-load-page]:nth-child(1)').addClass('is-active');
            $('[data-load-logo-page]:nth-child(1)').addClass('is-active');
            $('[data-load-menu-page]:nth-child(1)').addClass('is-active');
        }

        var header = menuTabItem.closest('.header');
        if (!header.length || window.innerWidth >= 1025) return;

        var logoMobile = $('.header-mobile .header__heading-link');
        var logoDesktop = header.find('.header__heading-link.is-active');

        if (logoDesktop.data('logo-mobile') === undefined) {
            logoMobile.find('img').addClass('logo-show');
            return;
        }

        logoMobile.html('<img src="' + logoDesktop.data('logo-mobile') + '" alt="' + logoDesktop.data('logo-mobile-alt') + '" style="max-width: ' + logoMobile.data('logo-width') + 'px; height: auto"/>');
        logoMobile.find('img').addClass('logo-show');
        if (pageUrl) logoMobile.attr('href', pageUrl);
    }

    renderLogoMobile();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site-speculationrules"] && !Shopify.designMode) return;
  try {
    
(function () {
    function initStickyHeader(scope) {
        var wrappers = (scope || document).querySelectorAll('[data-halo-sticky-header]');

        wrappers.forEach(function (wrapper) {
            if (wrapper.dataset.haloStickyReady === 'true') return;
            wrapper.dataset.haloStickyReady = 'true';

            var section = wrapper.closest('.section-header-navigation');
            if (!section) return;

            var stickyType = wrapper.getAttribute('data-sticky-type') || 'none';
            var placeholder = document.createElement('div');
            placeholder.className = 'halo-sticky-placeholder';
            placeholder.setAttribute('aria-hidden', 'true');
            wrapper.parentNode.insertBefore(placeholder, wrapper.nextSibling);

            var triggerTop = 0;
            var headerHeight = 0;
            var ticking = false;

            function getScrollTop() {
                return window.pageYOffset || document.documentElement.scrollTop || 0;
            }

            function isSticky() {
                return section.classList.contains('shopify-section-header-sticky');
            }

            function measure() {
                headerHeight = wrapper.offsetHeight || 0;

                if (isSticky() && placeholder.classList.contains('is-active')) {
                    triggerTop = placeholder.getBoundingClientRect().top + getScrollTop();
                } else {
                    triggerTop = wrapper.getBoundingClientRect().top + getScrollTop();
                }

                document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
            }

            function setSticky(active) {
                if (stickyType === 'none') return;

                if (active) {
                    headerHeight = wrapper.offsetHeight || headerHeight;
                    placeholder.style.height = headerHeight + 'px';
                    placeholder.classList.add('is-active');
                    section.classList.add('shopify-section-header-sticky', 'scrolled-past-header');
                    section.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show');
                    wrapper.classList.add('is-sticky');
                    document.body.classList.add('scrolled-header');
                } else {
                    section.classList.remove('shopify-section-header-sticky', 'shopify-section-header-hidden', 'shopify-section-header-show', 'animate', 'scrolled-past-header');
                    wrapper.classList.remove('is-sticky');
                    placeholder.classList.remove('is-active');
                    placeholder.style.height = '0px';
                    document.body.classList.remove('scrolled-header');
                }
            }

            function update() {
                ticking = false;

                if (stickyType === 'always') {
                    if (!isSticky()) measure();
                    setSticky(true);
                    return;
                }

                if (stickyType === 'on_scroll') {
                    var shouldStick = getScrollTop() > triggerTop;
                    setSticky(shouldStick);
                }
            }

            function requestUpdate() {
                if (ticking) return;
                ticking = true;
                window.requestAnimationFrame(update);
            }

            function refresh() {
                var active = isSticky();
                if (active) setSticky(false);
                measure();
                update();
            }

            measure();
            update();

            window.addEventListener('scroll', requestUpdate, { passive: true });
            window.addEventListener('resize', refresh);
            window.addEventListener('load', refresh);

            if (window.ResizeObserver) {
                var resizeObserver = new ResizeObserver(function () {
                    if (isSticky()) {
                        headerHeight = wrapper.offsetHeight || headerHeight;
                        placeholder.style.height = headerHeight + 'px';
                        document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
                    } else {
                        refresh();
                    }
                });
                resizeObserver.observe(wrapper);
            }
        });
    }

    initStickyHeader(document);

    document.addEventListener('DOMContentLoaded', function () {
        initStickyHeader(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
        initStickyHeader(event.target);
    });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site-tab-menu-short"] && !Shopify.designMode) return;
  try {
    
(function () {
    var stickyRoot = document.querySelector('sticky-header');
    var sticky = stickyRoot ? stickyRoot.querySelector('.header-nav-multi-site') : null;

    if (!sticky || customElements.get('sticky-header')) return;

    class StickyHeader extends HTMLElement {
        constructor() { super(); }

        connectedCallback() {
            this.header = document.querySelector('.section-header-navigation');
            this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
            this.headerBounds = {};
            this.setHeaderHeight();
            window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

            if (this.headerIsAlwaysSticky) {
                this.header.classList.add('shopify-section-header-sticky');
            }

            this.currentScrollTop = 0;
            this.preventReveal = false;
            this.predictiveSearch = this.querySelector('predictive-search');
            this.onScrollHandler = this.onScroll.bind(this);
            this.hideHeaderOnScrollUp = () => this.preventReveal = true;
            this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.addEventListener('scroll', this.onScrollHandler, false);
            this.createObserver();
        }

        setHeaderHeight() {
            if (this.header) document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
            this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
            window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
            if (!this.header) return;
            let observer = new IntersectionObserver((entries, observer) => {
                this.headerBounds = entries[0].intersectionRect;
                observer.disconnect();
            });
            observer.observe(this.header);
        }

        onScroll() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

            if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                if (this.preventHide) return;
                this.header.classList.add('scrolled-past-header');
                requestAnimationFrame(this.hide.bind(this));
            } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
                this.header.classList.add('scrolled-past-header');
                if (!this.preventReveal) {
                    requestAnimationFrame(this.reveal.bind(this));
                } else {
                    window.clearTimeout(this.isScrolling);
                    this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
                    requestAnimationFrame(this.hide.bind(this));
                }
            } else if (scrollTop <= this.headerBounds.top) {
                this.header.classList.remove('scrolled-past-header');
                requestAnimationFrame(this.reset.bind(this));
            }
            this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return;
                }
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
            this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return;
                }
                this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                this.header.classList.remove('shopify-section-header-hidden');
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return;
                }
                this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
            }
        }

        closeMenuDisclosure() {
            this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
            this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site-tab-menu-v3"] && !Shopify.designMode) return;
  try {
    
(function () {
    function initStickyHeader(scope) {
        var wrappers = (scope || document).querySelectorAll('[data-halo-sticky-header]');

        wrappers.forEach(function (wrapper) {
            if (wrapper.dataset.haloStickyReady === 'true') return;
            wrapper.dataset.haloStickyReady = 'true';

            var section = wrapper.closest('.section-header-navigation');
            if (!section) return;

            var stickyType = wrapper.getAttribute('data-sticky-type') || 'none';
            var placeholder = document.createElement('div');
            placeholder.className = 'halo-sticky-placeholder';
            placeholder.setAttribute('aria-hidden', 'true');
            wrapper.parentNode.insertBefore(placeholder, wrapper.nextSibling);

            var triggerTop = 0;
            var headerHeight = 0;
            var ticking = false;

            function getScrollTop() {
                return window.pageYOffset || document.documentElement.scrollTop || 0;
            }

            function isSticky() {
                return section.classList.contains('shopify-section-header-sticky');
            }

            function measure() {
                headerHeight = wrapper.offsetHeight || 0;

                if (isSticky() && placeholder.classList.contains('is-active')) {
                    triggerTop = placeholder.getBoundingClientRect().top + getScrollTop();
                } else {
                    triggerTop = wrapper.getBoundingClientRect().top + getScrollTop();
                }

                document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
            }

            function setSticky(active) {
                if (stickyType === 'none') return;

                if (active) {
                    headerHeight = wrapper.offsetHeight || headerHeight;
                    placeholder.style.height = headerHeight + 'px';
                    placeholder.classList.add('is-active');
                    section.classList.add('shopify-section-header-sticky', 'scrolled-past-header');
                    section.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show');
                    wrapper.classList.add('is-sticky');
                    document.body.classList.add('scrolled-header');
                } else {
                    section.classList.remove('shopify-section-header-sticky', 'shopify-section-header-hidden', 'shopify-section-header-show', 'animate', 'scrolled-past-header');
                    wrapper.classList.remove('is-sticky');
                    placeholder.classList.remove('is-active');
                    placeholder.style.height = '0px';
                    document.body.classList.remove('scrolled-header');
                }
            }

            function update() {
                ticking = false;

                if (stickyType === 'always') {
                    if (!isSticky()) measure();
                    setSticky(true);
                    return;
                }

                if (stickyType === 'on_scroll') {
                    var shouldStick = getScrollTop() > triggerTop;
                    setSticky(shouldStick);
                }
            }

            function requestUpdate() {
                if (ticking) return;
                ticking = true;
                window.requestAnimationFrame(update);
            }

            function refresh() {
                var active = isSticky();
                if (active) setSticky(false);
                measure();
                update();
            }

            measure();
            update();

            window.addEventListener('scroll', requestUpdate, { passive: true });
            window.addEventListener('resize', refresh);
            window.addEventListener('load', refresh);

            if (window.ResizeObserver) {
                var resizeObserver = new ResizeObserver(function () {
                    if (isSticky()) {
                        headerHeight = wrapper.offsetHeight || headerHeight;
                        placeholder.style.height = headerHeight + 'px';
                        document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
                    } else {
                        refresh();
                    }
                });
                resizeObserver.observe(wrapper);
            }
        });
    }

    initStickyHeader(document);

    document.addEventListener('DOMContentLoaded', function () {
        initStickyHeader(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
        initStickyHeader(event.target);
    });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site-wave-search-speculationrules"] && !Shopify.designMode) return;
  try {
    
(function () {
    var desktopMq = window.matchMedia('(min-width: 1025px)');

    function initSticky(scope) {
        if (!desktopMq.matches) return;

        (scope || document).querySelectorAll('[data-halo-sticky-header]').forEach(function (wrapper) {
            if (wrapper.dataset.haloStickyReady === 'true') return;
            wrapper.dataset.haloStickyReady = 'true';

            var section = wrapper.closest('.section-header-nav-multi-site, .section-header-navigation');
            if (!section) return;

            section.classList.remove('animate', 'shopify-section-header-hidden', 'shopify-section-header-show');
            wrapper.classList.remove('animate');

            var stickyType = wrapper.getAttribute('data-sticky-type') || 'none';
            var placeholder = document.createElement('div');
            var triggerTop = 0;
            var ticking = false;

            placeholder.className = 'halo-sticky-placeholder';
            placeholder.setAttribute('aria-hidden', 'true');
            wrapper.parentNode.insertBefore(placeholder, wrapper.nextSibling);

            function scrollTop() {
                return window.pageYOffset || document.documentElement.scrollTop || 0;
            }

            function measure() {
                var rect = (placeholder.classList.contains('is-active') ? placeholder : wrapper).getBoundingClientRect();
                triggerTop = rect.top + scrollTop();
                document.documentElement.style.setProperty('--header-height', (wrapper.offsetHeight || 0) + 'px');
            }

            function setSticky(active) {
                if (stickyType === 'none') active = false;

                if (!active) {
                    section.classList.remove('shopify-section-header-sticky', 'shopify-section-header-hidden', 'shopify-section-header-show', 'animate', 'scrolled-past-header');
                    wrapper.classList.remove('is-sticky');
                    placeholder.classList.remove('is-active');
                    placeholder.style.height = '0px';
                    document.body.classList.remove('scrolled-header');
                    return;
                }

                placeholder.style.height = (wrapper.offsetHeight || 0) + 'px';
                placeholder.classList.add('is-active');
                section.classList.remove('animate', 'shopify-section-header-hidden', 'shopify-section-header-show');
                wrapper.classList.remove('animate');
                section.classList.add('shopify-section-header-sticky', 'scrolled-past-header');
                wrapper.classList.add('is-sticky');
                document.body.classList.add('scrolled-header');
            }

            function update() {
                ticking = false;
                if (!desktopMq.matches) {
                    setSticky(false);
                    return;
                }
                if (stickyType === 'always') {
                    setSticky(true);
                    return;
                }
                setSticky(stickyType === 'on_scroll' && scrollTop() > triggerTop);
            }

            function requestUpdate() {
                if (ticking) return;
                ticking = true;
                window.requestAnimationFrame(update);
            }

            measure();
            update();
            window.addEventListener('scroll', requestUpdate, { passive: true });
            window.addEventListener('resize', function () { measure(); update(); });
            if (window.ResizeObserver) new ResizeObserver(function () { measure(); update(); }).observe(wrapper);
        });
    }

    initSticky(document);
    document.addEventListener('DOMContentLoaded', function () { initSticky(document); });
    document.addEventListener('shopify:section:load', function (event) { initSticky(event.target); });
    if (desktopMq.addEventListener) desktopMq.addEventListener('change', function (event) { if (event.matches) initSticky(document); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-nav-multi-site"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-multi-site');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);
              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    document.addEventListener('DOMContentLoaded', () => {customElements.define('sticky-header', StickyHeader)});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-basic"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-basic');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-compact"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-compact');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-full-elements"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-full-elements');
if (sticky != undefined || sticky != null) {

    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-hamburger"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-hamburger');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');
          this.headerBounds = {};
          this.setHeaderHeight();
          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };
          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;
          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('load', this.checkLoadPosition.bind(this));
          window.addEventListener('scroll', this.onScrollHandler, false);
          this.createObserver();
        }
        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }
        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('load', this.checkLoadPosition);
          window.removeEventListener('scroll', this.onScrollHandler);
        }
        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });
          observer.observe(this.header);
        }
        checkLoadPosition() {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const headerGr = document.querySelectorAll(".shopify-section-group-header-group");

            if(headerGr[0].classList.contains('shopify-section-header-sticky')) {
                if(scrollTop > headerGr[0].offsetHeight && !this.header.classList.contains('scrolled-past-header')) {
                    this.header.classList.add('shopify-section-header-hidden');
                }
            } else {
                headerGr.forEach(item => {
                    if(item.classList.contains('shopify-section-header-sticky') ) {
                        const itemPrev = item.previousElementSibling;
                        const itemPrevHeight = itemPrev.offsetHeight;
                        const itemPrevTop = itemPrev.offsetTop;

                        if(scrollTop > itemPrevTop + itemPrevHeight && !this.header.classList.contains('scrolled-past-header')) {
                            this.header.classList.add('shopify-section-header-hidden');
                        }
                    }
                });
            }
        }
        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');
            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);
              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }
          this.currentScrollTop = scrollTop;
        }
        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                    document.querySelector('body').classList.add("section-header-is-hidden")
                }
            }
          this.closeMenuDisclosure();
        }
        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
                  document.querySelector('body').classList.remove("section-header-is-hidden")
              }
            }
        }
        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }
    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-haozzha"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-plain');

if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        document.body.classList.remove('scrolled-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-left-aligned"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-left-aligned');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-plain"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-plain');

if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        document.body.classList.remove('scrolled-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-utility"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-utility');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

    customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-navigation-vertical-menu"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-vertical-menu');
if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
        constructor() {
          super();
        }

        connectedCallback() {
          this.header = document.querySelector('.section-header-navigation');
          this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

          this.headerBounds = {};

          this.setHeaderHeight();

          window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

          if (this.headerIsAlwaysSticky) {
            this.header.classList.add('shopify-section-header-sticky');
          };

          this.currentScrollTop = 0;
          this.preventReveal = false;
          this.predictiveSearch = this.querySelector('predictive-search');
          this.onScrollHandler = this.onScroll.bind(this);
          this.hideHeaderOnScrollUp = () => this.preventReveal = true;

          this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.addEventListener('scroll', this.onScrollHandler, false);

          this.createObserver();
        }

        setHeaderHeight() {
          document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
        }

        disconnectedCallback() {
          this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
          window.removeEventListener('scroll', this.onScrollHandler);
        }

        createObserver() {
          let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
          });

          observer.observe(this.header);
        }

        onScroll() {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
          if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            this.header.classList.add('scrolled-past-header');
            requestAnimationFrame(this.hide.bind(this));
          } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            this.header.classList.add('scrolled-past-header');

            if (!this.preventReveal) {
              requestAnimationFrame(this.reveal.bind(this));
            } else {
              window.clearTimeout(this.isScrolling);

              this.isScrolling = setTimeout(() => {
                this.preventReveal = false;
              }, 66);

              requestAnimationFrame(this.hide.bind(this));
            }
          } else if (scrollTop <= this.headerBounds.top) {
            this.header.classList.remove('scrolled-past-header');
            requestAnimationFrame(this.reset.bind(this));
          }

          this.currentScrollTop = scrollTop;
        }

        hide() {
            if (this.headerIsAlwaysSticky != null) {
                if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky');
                    return
                } else {
                    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                    this.header.classList.remove('shopify-section-header-show');
                }
                if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                    $('.vertical-menu').addClass('vertical-menu__hide');
                }
            }
          this.closeMenuDisclosure();
        }

        reveal() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
                  this.header.classList.remove('shopify-section-header-hidden');
              }
            }
        }

        reset() {
            if (this.headerIsAlwaysSticky != null) {
              if (this.headerIsAlwaysSticky === 'always') {
                    this.header.classList.add('shopify-section-header-sticky', 'animate');
                    return
                } else {
                  this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
              }
              if(!$('.vertical-menu').hasClass('vertical-menu__style_3')){
                  if (document.body.classList.contains('template-index')) {
                      if ($('.vertical-menu').hasClass('vertical-menu__hide')) {
                          $('.vertical-menu').removeClass('vertical-menu__hide');
                      }
                  }
              }
            }
        }

        closeMenuDisclosure() {
          this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
          this.disclosures.forEach(disclosure => disclosure.close());
        }
    }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["navigation-glass-wave"] && !Shopify.designMode) return;
  try {
    
var sticky = document.getElementsByTagName('sticky-header')[0].querySelector('.header-nav-plain');

if (sticky != undefined || sticky != null) {
    class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header-navigation');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type');

      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        document.body.classList.add('scrolled-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        document.body.classList.remove('scrolled-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
        if (this.headerIsAlwaysSticky != null) {
            if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky');
                return
            } else {
                this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
                this.header.classList.remove('shopify-section-header-show');
            }
        }
      this.closeMenuDisclosure();
    }

    reveal() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-show', 'animate');
              this.header.classList.remove('shopify-section-header-hidden');
          }
        }
    }

    reset() {
        if (this.headerIsAlwaysSticky != null) {
          if (this.headerIsAlwaysSticky === 'always') {
                this.header.classList.add('shopify-section-header-sticky', 'animate');
                return
            } else {
              this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-show', 'shopify-section-header-sticky', 'animate');
          }
        }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);
}

  } catch(e) { console.error(e); }
})();
})();
